import SubscribeSection from '../../../UI/SubscribeSection/SubscribeSection';
import { Grid } from '@mui/material';

const Subscribe = () => {
  return (
    <Grid
      container
      spacing={{ xs: 4, lg: 2 }}
      alignItems='center'
      sx={{ pt: { xs: '3rem', lg: '0rem' } }}
      justifyContent='center'>
      <SubscribeSection />
    </Grid>
  );
};

export default Subscribe;
